class CountryPickerDrawer extends HTMLElement {
  countryPickerDrawer = document.querySelector('country-picker-drawer')
  modalOverlay = this.countryPickerDrawer.querySelector('.modal-overlay')

  constructor () {
    super()
  }

  connectedCallback () {
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.hide()
      }
    })

    this.modalOverlay.addEventListener('click', () => {
      this.hide()
    })
  }

  getVisibleState () {
    return this.countryPickerDrawer.classList.contains('hidden')
  }

  show () {
    this.countryPickerDrawer.setAttribute('aria-hidden', false)
    this.countryPickerDrawer.classList.remove('hidden')
    document.body.classList.add('overflow-hidden')
  }

  hide () {
    this.countryPickerDrawer.setAttribute('aria-hidden', true)
    this.countryPickerDrawer.classList.add('hidden')
    document.body.classList.remove('overflow-hidden')
  }
}

window.customElements.define('country-picker-drawer', CountryPickerDrawer)

class CountryPickerDrawerButton extends CountryPickerDrawer {
  constructor () {
    super()
  }

  connectedCallback () {
    this.addEventListener('click', (event) => {
      if (!this.getVisibleState()) {
        this.hide()
      } else {
        this.show()
      }
    })
  }
}

window.customElements.define('country-picker-drawer-button', CountryPickerDrawerButton)
